import { api } from './client';

export const walletApi = {
  challenge: (address: string) =>
    api<{ nonce: string; message: string; expiresAt: string }>('/api/wallet/challenge', {
      method: 'POST',
      body: { address },
    }),

  link: (data: { message: string; signature: string }) =>
    api<{ wallet: { id: string; address: string; linkedAt: string } }>('/api/wallet/link', {
      method: 'POST',
      body: data,
    }),

  get: () => api<{ wallets: Array<{ id: string; address: string; linkedAt: string }> }>('/api/wallet'),

  delete: (walletId: string) =>
    api<{ ok: boolean }>(`/api/wallet/${walletId}`, { method: 'DELETE' }),
};
